
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CPGaugeComponent } from './cp-gauge.component';

@NgModule({
  declarations: [CPGaugeComponent],
  exports: [CPGaugeComponent],
  imports: [CommonModule]
})
export class GaugeChartModule {}

